export default __webpack_public_path__ + "static/media/traders-tab.6946865c.svg";